'use client'

import useLogin from '@hook/useLogin'
import { eventTypes, liveStatus } from '@lib/config'
import { detail } from '@lib/route/event'
import { Button } from '@comp/material'
import { get } from 'lodash-es'
import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'

export default function LiveStatusButton({
  data
}) {
  const locale = useLocale()
  const ts = useTranslations('live')
  const { isLogin, user } = useLogin()

  const buttonText = useMemo(() => {
    let res = ts('viewNow')

    const isOpenCourse = data.data_type === eventTypes.openCourse
    const isOwner = isLogin && get(user, 'id') === get(data, 'live_stream.broad_caster.userId')
    const status = get(data, 'live_stream.status')
    const memberStatus = get(data, 'live_stream.member_status')
    const signRequire = get(data, 'sign_require')

    // 直播未开始
    if (status === liveStatus.notStart) {
      if (isOpenCourse && isOwner) {
        res = ts('viewNow')
      } else if (signRequire) {
        // eslint-disable-next-line default-case
        switch (memberStatus) {
          case 'out':
            res = data.button
            break
          case 'pending':
            res = ts('statusPending')
            break
          case 'in':
            res = ts('registered')
            break
        }
      } else if (status === liveStatus.live) {
        // 直播中
        if (signRequire) {
          // eslint-disable-next-line default-case
          switch (memberStatus) {
            case 'out':
              res = ts('viewNow')
              break
            case 'pending':
              res = ts('statusPending')
              break
            case 'in':
              res = ts('viewNow')
              break
          }
        } else {
          res = ts('viewNow')
        }
      } else if (status === liveStatus.end) {
        if (data.has_record) {
          // 查看回放
          res = ts('playback2')
        } else {
          // 立即查看
          res = ts('viewNow')
        }
      }
    }

    return res
  }, [data, ts, isLogin, user])

  return (
    <Button
      variant="contained"
      className="pointer-events-auto"
      sx={{ borderRadius: '30px' }}
      href={detail({ eventType: data.data_type, eventId: data.live_stream.event_id }, locale)}
    >
      {buttonText}
    </Button>
  )
}
